import { Component, effect, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../../../../core/service/base/his-ui.service';
import { HisNotificationService } from '../../../../../core/service/notifications/his-notification.service';
import { HisCoreSharedModule } from '../../../../../core/his-core-shared.module';
import { Subscription, tap } from 'rxjs';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { StoredReport } from '../../../../model/stored-report';
import { BiAnalysisService } from '../../../../services/bi-analysis.service';

@Component( {
    selector: 'his-bi-save-bi-analysis',
    imports: [HisCoreSharedModule, Dialog, FormsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './save-bi-analysis.component.html',
} )
export class SaveBiAnalysisComponent implements OnDestroy {
    private notificationService = inject( HisNotificationService );
    protected hisUi = inject( HisUiService );
    private biAnalysisService = inject( BiAnalysisService );

    saveDialog = false;
    reallyWantToSaveDialog = false;
    storedReportDefinitions: StoredReport[] = [];
    sachgebiete: string = '';
    subscriptions: Subscription[] = [];

    @Input( { required: true } ) report!: StoredReport;
    @Output() readonly reportChanged = new EventEmitter<StoredReport>();

    ngOnDestroy() {
        for ( let subscription of this.subscriptions ) {
            subscription.unsubscribe();
        }
    }

    saveDialogClick() {
        this.saveDialog = true;
        this.getReportDefinitions();
    }

    saveReportDefinition() {
        const subscription = this.biAnalysisService.persistReportDefinition( this.report ).pipe(
            tap( ( id: number ) => {
                this.report.id = id;

                this.reportChanged.emit( {
                    ...this.report
                } );

                this.notificationService.success(
                    this.hisUi.translate( 'cs.bia.analysis.success.save', this.report.name ?? '' ),
                    this.hisUi.translate( 'view.success.save' ),
                );
            } ),
        ).subscribe();
        this.subscriptions.push( subscription );
        this.saveDialog = false;
        this.reallyWantToSaveDialog = false;
    }

    doesReportDefinitionExist( name?: string ) {
        this.report.id = null;
        for ( const storedReportDefinition of this.storedReportDefinitions ) {
            if ( storedReportDefinition.name === name ) {
                this.reallyWantToSaveDialog = true;
                this.report.id = storedReportDefinition.id;
                return;
            }
        }
        this.saveReportDefinition();
    }

    getReportDefinitions() {
        const subscription = this.biAnalysisService.getReportDefinitions()
            .pipe(
                tap( ( reportDefinitions: StoredReport[] ) => {
                    this.storedReportDefinitions = reportDefinitions;
                } ),
            ).subscribe();
        this.subscriptions.push( subscription );
    }

    saveEnabled(): boolean {
        if ( this.report.name ) {
            if ( this.report.name.length > 0 ) {
                return true;
            }
        }
        return false;
    }
}
